import { type RouteLocation, type RouteRecordRaw } from 'vue-router';

import { ROUTE_DATA } from '@/constants/routes.constants';
import { routerHelper } from '@/services/router-helper';

const ConferenceOverview = (): unknown => {
    return import(/* webpackPrefetch: true */ './conference-overview-page.vue');
};

export const conferenceOverviewRoute: RouteRecordRaw = {
    ...ROUTE_DATA.CONFERENCE_OVERVIEW_PAGE,
    components: {
        main: ConferenceOverview
    },
    props: {
        main(route: RouteLocation): { conferenceId?: number } {
            return { conferenceId: routerHelper.parseParamToInt(route.params.id as string) };
        }
    }
};
